import React, { useEffect } from 'react';
import { CLIENT_APP_ORIGIN } from '../shared/ClientAccountDoor';
const redirect = (url) => window.location.replace(url);
export default function RetiredPortal({ onRedirect = redirect }) {
    const destination = `${CLIENT_APP_ORIGIN}/${window.location.search}${window.location.hash}`;
    useEffect(() => { onRedirect(destination); }, [destination, onRedirect]);
    return <main style={{ padding: '2rem' }}><h1>Your client app has moved</h1><a href={destination}>Open book.therideatl.com</a></main>;
}
